module.exports = __webpack_public_path__ + "static/media/ivn_info.f65c7b45.svg";